export class PackageExportStartedMessage {
    public packageName: string;

    constructor(packageName: string) {
        this.packageName = packageName;
    }
}